export default "__VITE_ASSET__38fbd40e__"